import React from 'react';
import { InactiveConversation } from '../styled';

export const PauseBlockerCustomerInactive = () => {
  return (
    <InactiveConversation>
      <h3>Usuário em pausa ou deslogado!</h3>
      <span>
        Seu usuário não está logado em nenhuma fila, ou está em pausa. Realize o
        login no caso de estar deslogado ou retire a pausa
      </span>
    </InactiveConversation>
  );
};
